import request from "@/utils/request"

export function getClassifyList(params){
    return request({
        url:"/classify/getClassifyByType",
        method:"get",
        params:params
    })
}
